import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff053e44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-actions" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = {
  class: "breadcrumb",
  "aria-label": "breadcrumbs"
}
const _hoisted_4 = { href: "#" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "is-active" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    "aria-current": "page"
  }, "Edit Classification")
], -1))
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = {
  key: 2,
  class: "content-area"
}
const _hoisted_8 = { class: "title is-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title is-4" }, "Taxonomy 1 Configuration", -1))
const _hoisted_10 = { class: "title-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title is-4" }, "Taxonomy 2 Configuration", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Add Taxonomy 2")


import TaxonomyConfiguration from "../../Modules/Admin/Classification/TaxonomyConfiguration.vue";
import IconButton from "../../Modules/General/IconButton.vue";
import TaxonomyList from "../../Modules/Admin/Classification/TaxonomyList.vue";
import TaxonomyExtracts from "../../Modules/Admin/Classification/TaxonomyExtracts.vue";
import TaxonomyRules from "../../Modules/Admin/Classification/TaxonomyRules.vue";
import swal from "sweetalert2";
import * as xlsx from "xlsx";
import { saveAs } from "file-saver";
import ClassificationSaveModal from "./ClassificationSaveModal.vue";

const __default__ = {
  title: "Traffic Classification",
  components: {
    IconButton,
    TaxonomyList,
    TaxonomyConfiguration,
    TaxonomyExtracts,
    TaxonomyRules,
    ClassificationSaveModal,
  },
};
import { UseClassificationStore } from "../../Modules/State/Stores/ClassificationStore";
import { computed, ComputedRef, onMounted, Ref, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { onBeforeRouteLeave } from "vue-router";
import { each } from "lodash";
import axios from "axios";
import { UseMainStore } from "../../Modules/State/SingleViewStorePinia";
import { UseProgramStore } from "../../Modules/State/Stores/ProgramStore";
import { UseClassification } from "./Hooks/UseClassification";
import {
  IDenormalised,
  ITaxonomy,
  IClassificationDownloadData,
  IDenormalisedFirstLevelRules,
  IDenormalisedFirstLevelExtracts,
  IDenormalisedChildren,
} from "../../Modules/State/Typings/SingleViewStoreTypes";
import { UseAxiosErrorHelper } from "../../Helper/ThirdParty/UseAxiosErrorHelper";

//Load in store getters and state

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { getApiBaseUrl } = storeToRefs(UseMainStore());
const { getCurrentProgram, getCurrentProgramName } = storeToRefs(
  UseProgramStore()
);
const {
  denormalised,
  taxonomyOnes: taxonomies,
  getTaxonomies,
  getRules: getTaxonomyRules,
  getExtracts: getTaxonomyExtracts,
} = storeToRefs(UseClassificationStore());

//Load in store and hook actions
const { setShowSidebar, renameTaxonomy, setTaxonomyCondition } =
  UseClassificationStore();
const {
  loadClassification,
  addTax2,
  swapTax2,
  updateRule,
  updateExtract,
  addRule,
  removeRule,
  deleteTaxonomy,
} = UseClassification();

const { set403Redirect, set403Text } = UseAxiosErrorHelper();

//Local data

const _selectedClassificationId = ref<number>(0);
const initialDenormalised = ref<IDenormalised[]>([]);
const loading = ref<boolean>(false);
const saveModalOpen = ref<boolean>(false);

//Computed
const selectedClassification = computed(() => {
  if (_selectedClassificationId.value <= 0) return taxonomies.value[0];
  return (
    taxonomies.value.find((c) => c.id === _selectedClassificationId.value) ||
    taxonomies.value[0]
  );
});

const selectedClassificationIdHelper = (
  taxonomies: Ref<ITaxonomy[]>
): number => {
  const taxonomy = taxonomies.value.find(
    (c) => c.id === _selectedClassificationId.value
  );
  if (taxonomy) {
    return _selectedClassificationId.value;
  }
  return taxonomies.value.length > 0 ? taxonomies.value[0].id : 0;
};

const selectedClassificationId = computed({
  get(): number {
    return selectedClassificationIdHelper(taxonomies);
  },
  set(val: number) {
    _selectedClassificationId.value = val;
  },
});

//Methods

const addTax2Handler = (e: Event) => {
  const target = e.currentTarget as HTMLElement;
  addTax2(selectedClassificationId.value, target, "");
};

const swapTaxHandler = (index: number, delta: number) => {
  if (selectedClassification && selectedClassification.value) {
    swapTax2(index, delta, selectedClassification as ComputedRef<ITaxonomy>);
  }
};

const save = () => {
  loading.value = true;
  try {
    axios
      .post(
        getApiBaseUrl.value +
          "/programs/" +
          getCurrentProgram.value +
          "/admin/classification",
        denormalised.value
      )
      .then((res) => {
        if (res) {
          const { data } = res.data;
          loading.value = false;
          saveModalOpen.value = false;
          initialDenormalised.value = denormalised.value;
          if (data.success) {
            swal.fire({
              type: "success",
              title: "Success",
              text: "The traffic classification set has been saved",
              confirmButtonText: "Okay",
            });
          } else {
            swal.fire({
              type: "error",
              title: "Error",
              text: "There was an error saving. Refresh the page. Please contact us if this keeps happening.",
              confirmButtonText: "Okay",
            });
          }
        }
      })
      .catch(() => {
        loading.value = false;
        saveModalOpen.value = false;
        swal.fire({
          type: "error",
          title: "Error",
          text: "There was an error saving",
          confirmButtonText: "Okay",
        });
      });
  } catch (error) {
    loading.value = false;
    saveModalOpen.value = false;
    swal.fire({
      type: "error",
      title: "Error",
      text: "he browser has timed out making a request to save traffic classification - this is usually due to a large traffic classification tree being sent across. Please check in a few minutes if the request has been successful.",
      confirmButtonText: "Okay",
    });
  }
};
const download = () => {
  let data: IClassificationDownloadData[] = [];

  let ruleF = function (r: IDenormalisedFirstLevelRules) {
    return (
      r.field +
      " " +
      r.match_type +
      (["exists", "not exists", "empty", "not empty"].includes(r.match_type)
        ? ""
        : " " + r.expected_value)
    );
  };
  let child = function (
    c: IDenormalised | IDenormalisedChildren,
    level: number,
    append: string,
    arrAddition: IClassificationDownloadData[]
  ) {
    let rules: IDenormalisedFirstLevelRules =
        {} as IDenormalisedFirstLevelRules,
      after: IDenormalisedFirstLevelExtracts[] = [],
      costlink = "";

    each(c.rules, function (childrule, index: number) {
      rules["rule_" + index.toString()] = ruleF(childrule);
    });

    each(c.extracts, function (childExtract: IDenormalisedFirstLevelExtracts) {
      if (childExtract.mapped_to !== "costlink") {
        after.push(childExtract);
      } else {
        costlink = childExtract.field;
      }
    });

    data.push({
      type: append + "Taxonomy " + level.toString(),
      title: c.title,
      join_type: c.join_type,
      costlink: costlink,
      ...rules,
    });

    each(after, function (a) {
      data.push({
        type:
          append +
          "  " +
          a.mapped_to.charAt(0).toUpperCase() +
          a.mapped_to.slice(1),
        title: a.field,
        join_type: "",
        costlink: "",
      });
    });

    // Children
    each(c.children, function (cc) {
      child(cc, level + 1, "    " + append, arrAddition);
    });

    return arrAddition;
  };
  each(denormalised.value, function (t1) {
    child(t1, 1, "", data);
  });

  let wb = xlsx.utils.book_new(),
    ws = xlsx.utils.json_to_sheet(data);

  xlsx.utils.book_append_sheet(wb, ws, "Classification");
  saveAs(
    new Blob([xlsx.write(wb, { bookType: "xlsx", type: "array" })], {
      type: "application/octet-stream",
    }),
    "Classification.xlsx"
  );
};

const isMounted = ref(false);
onMounted(() => {
  setShowSidebar(true);
  isMounted.value = true;
  //Adjust axios interceptors
  set403Redirect("/");
  set403Text("You don't have access to admin resources");
});
onBeforeRouteLeave(() => {
  setShowSidebar(false);
  isMounted.value = false;
});

watch(
  getCurrentProgram,
  () => {
    loadClassification(getCurrentProgram.value).then(
      () => (initialDenormalised.value = denormalised.value)
    );
  },
  { immediate: true }
);
watch(initialDenormalised, (val, oldVal) => {
  if (val.length !== oldVal.length) {
    _selectedClassificationId.value = val[0].id;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_o_button = _resolveComponent("o-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_o_loading, { active: loading.value }, null, 8, ["active"]),
    (isMounted.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#header-actions"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("nav", _hoisted_3, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", _hoisted_4, [
                      _createElementVNode("strong", null, _toDisplayString(_unref(getCurrentProgramName)), 1)
                    ])
                  ]),
                  _hoisted_5
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(IconButton, {
                icon: "download",
                label: "Download",
                onClick: download
              }),
              _createVNode(IconButton, {
                icon: "content-save",
                label: "Save",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (saveModalOpen.value = true))
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (isMounted.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#sidebar"
        }, [
          _createVNode(TaxonomyList, {
            "selected-taxonomy": _selectedClassificationId.value,
            "onUpdate:selected-taxonomy": _cache[1] || (_cache[1] = ($event: any) => ((_selectedClassificationId).value = $event))
          }, null, 8, ["selected-taxonomy"])
        ]))
      : _createCommentVNode("", true),
    (_unref(selectedClassification))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("h1", _hoisted_8, _toDisplayString(_unref(selectedClassification).title), 1),
          _hoisted_9,
          _createVNode(TaxonomyConfiguration, {
            "onUpdate:title": _cache[6] || (_cache[6] = ($event: any) => (
          _unref(renameTaxonomy)({
            id: _unref(selectedClassificationId),
            name: $event.target.value,
          })
        )),
            title: _unref(selectedClassification).title
          }, {
            default: _withCtx(() => [
              (_unref(selectedClassification))
                ? (_openBlock(), _createBlock(TaxonomyExtracts, {
                    key: 0,
                    extracts: _unref(getTaxonomyExtracts)(_unref(selectedClassification).extracts),
                    "onUpdate:extract": _cache[2] || (_cache[2] = ($event: any) => (_unref(updateExtract)(_unref(selectedClassificationId), $event)))
                  }, null, 8, ["extracts"]))
                : _createCommentVNode("", true),
              _createVNode(TaxonomyRules, {
                "onUpdate:condition": _cache[3] || (_cache[3] = ($event: any) => (
            _unref(setTaxonomyCondition)({
              id: _unref(selectedClassificationId),
              condition: $event.target.value,
            })
          )),
                condition: _unref(selectedClassification).join_type,
                rules: _unref(getTaxonomyRules)(_unref(selectedClassification).rules),
                "onUpdate:rule": _unref(updateRule),
                "onDelete:rule": _cache[4] || (_cache[4] = ($event: any) => (_unref(removeRule)(_unref(selectedClassificationId), $event))),
                onAddRule: _cache[5] || (_cache[5] = ($event: any) => (_unref(addRule)(_unref(selectedClassificationId))))
              }, null, 8, ["condition", "rules", "onUpdate:rule"])
            ]),
            _: 1
          }, 8, ["title"]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_o_button, {
              "icon-left": "plus",
              rounded: "",
              onClick: addTax2Handler
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createVNode(_TransitionGroup, {
            name: "tax-2-list",
            tag: "div",
            class: "tax-2-list",
            ref: "tax2list"
          }, {
            default: _withCtx(() => [
              (_unref(selectedClassification).children)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(getTaxonomies)(
            _unref(selectedClassification).children
          ), (child, index) => {
                    return (_openBlock(), _createBlock(TaxonomyConfiguration, {
                      key: child.id,
                      index: index,
                      title: child.title,
                      "onUpdate:title": ($event: any) => (
            _unref(renameTaxonomy)({ id: child.id, name: $event.target.value })
          ),
                      onSwap: ($event: any) => (swapTaxHandler(index, $event)),
                      "is-first": index === 0,
                      "is-last": index === _unref(selectedClassification).children.length - 1
                    }, {
                      buttons: _withCtx(() => [
                        _createVNode(IconButton, {
                          onClick: ($event: any) => (_unref(deleteTaxonomy)(child.id)),
                          label: "Delete",
                          icon: "delete"
                        }, null, 8, ["onClick"]),
                        _createVNode(IconButton, {
                          icon: "chevron-up",
                          label: "Move up",
                          onClick: ($event: any) => (swapTaxHandler(index, -1)),
                          style: _normalizeStyle({
                visibility: index === 0 ? 'hidden' : 'visible',
              })
                        }, null, 8, ["onClick", "style"]),
                        _createVNode(IconButton, {
                          icon: "chevron-down",
                          label: "Move down",
                          onClick: ($event: any) => (swapTaxHandler(index, 1)),
                          style: _normalizeStyle({
                visibility:
                  index === _unref(selectedClassification).children.length - 1
                    ? 'hidden'
                    : 'visible',
              })
                        }, null, 8, ["onClick", "style"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(TaxonomyExtracts, {
                          extracts: _unref(getTaxonomyExtracts)(child.extracts),
                          "parent-extracts": 
              _unref(getTaxonomyExtracts)(_unref(selectedClassification).extracts)
            ,
                          "onUpdate:extract": ($event: any) => (_unref(updateExtract)(child.id, $event))
                        }, null, 8, ["extracts", "parent-extracts", "onUpdate:extract"]),
                        _createVNode(TaxonomyRules, {
                          condition: child.join_type,
                          "onUpdate:condition": ($event: any) => (
              _unref(setTaxonomyCondition)({
                id: child.id,
                condition: $event.target.value,
              })
            ),
                          rules: _unref(getTaxonomyRules)(child.rules),
                          "onUpdate:rule": _unref(updateRule),
                          "onDelete:rule": ($event: any) => (_unref(removeRule)(child.id, $event)),
                          onAddRule: ($event: any) => (_unref(addRule)(child.id))
                        }, null, 8, ["condition", "onUpdate:condition", "rules", "onUpdate:rule", "onDelete:rule", "onAddRule"])
                      ]),
                      _: 2
                    }, 1032, ["index", "title", "onUpdate:title", "onSwap", "is-first", "is-last"]))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512)
        ]))
      : _createCommentVNode("", true),
    _createVNode(ClassificationSaveModal, {
      open: saveModalOpen.value,
      "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((saveModalOpen).value = $event)),
      initialData: initialDenormalised.value,
      newData: _unref(denormalised),
      onSave: save
    }, null, 8, ["open", "initialData", "newData"])
  ]))
}
}

})